import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { MutationKey } from '@shared/config';
import { vacancyApi } from '../vacancyApi';
import {
  type DetailVacanciesTemplate,
  type UpdateVacancyTemplateActivityRequest,
} from '../types';
import type { AxiosError } from 'axios';
import type { TFormErrorResponse } from '@shared/types';

export const useUpdateVacancyTemplateActivity = (
  id: number
): UseMutationResult<
  DetailVacanciesTemplate,
  AxiosError<TFormErrorResponse>,
  UpdateVacancyTemplateActivityRequest
> => {
  return useMutation({
    mutationKey: [MutationKey.UPDATE_VACANCY_TEMPLATE_ACTIVITY, id],
    mutationFn: (params: UpdateVacancyTemplateActivityRequest) =>
      vacancyApi.updateVacancyTemplateActivity(id, params),
  });
};
